export const transactionSuccess = {
  title: 'Transaction Success',
  body: 'Your order simulation has been processed and thank you for using Midtrans Demo Store.'
};

export const transactionFailed = {
  title: 'Transaction Failed',
  body: 'Sorry, something went wrong. We are truly apologize for the inconvenience. Please try again.'
};
